import { useEffect, useState } from 'react';
import { Theme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import IframeResizer from 'iframe-resizer-react';

import { Loader } from '../../../../../common/loader';
import endpoints from '../../../../../../api/endpoints';
import { useFetch } from '../../../../../../api/useFetch';
import { ClientInfo } from '../../../../../../api/interfaces';
import { EXTERNAL_PATH } from '../../../../../routes/paths';

import { handleOpenEditor } from './helpers';

interface StyleProps {
  loading: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  iframeResizer: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    display: ({ loading }: StyleProps) => (loading ? 'none' : 'block')
  },
  loaderContainer: {
    ...theme.styles.center,
    height: '100%'
  }
}));

const Editor = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [iframeLoading, setIframeLoading] = useState(true);
  const classes = useStyles({ loading });

  const { loading: clientInfoLoading, data = {} as ClientInfo } = useFetch<ClientInfo>({
    pathname: endpoints.clientInfo
  });

  const handleLoad = () => {
    setIframeLoading(false);
  };

  useEffect(() => {
    if (!iframeLoading && !clientInfoLoading) {
      setLoading(false);
    }
  }, [clientInfoLoading, iframeLoading]);

  if (clientInfoLoading) {
    return (
      <div className={classes.loaderContainer}>
        <Loader />
      </div>
    );
  }

  if (!data?.msisdn && !clientInfoLoading) {
    return (
      <div className={classes.loaderContainer}>
        An error occurred while getting information about your phone number. The USSD Editor can not be open.
      </div>
    );
  }

  return (
    <>
      <IframeResizer
        onLoad={handleLoad}
        frameBorder={0}
        src={handleOpenEditor(location.search, EXTERNAL_PATH.USSD_EDITOR, data.msisdn)}
        scrolling={true}
        className={classes.iframeResizer}
      />
      {iframeLoading && (
        <div className={classes.loaderContainer}>
          <Loader />
        </div>
      )}
    </>
  );
};

export default Editor;
